import * as React from 'react';
import { connect } from 'react-redux';
import * as CompanyActions from '../actions/Company';
import * as ChatActions from '../../chat/actions/Chat';
import * as ProfileActions from '../actions/Profile';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';

import Chatbox from '../../chat/components/Chatbox';
import ChatIntroCard from '../components/chat/ChatIntroCard';
import ChatWelcome from '../components/chat/ChatWelcome';
import VideoChat from '../components/chat/VideoChat';

import config, { getCompanyId } from '../../shared/config';

class ChatPage extends React.Component {

  async componentDidMount() {
    const { match: { params } } = this.props;
    let companyId = getCompanyId(params.companySlug);
    let eventId = config.eventId;
    console.log("Loading company with id", companyId);
    await this.props.loadCompanyData(eventId, companyId);
    await this.props.loadProfile();
    this.props.subToChat();
  }

  async componentWillUnmount() {
    this.props.leaveChat();
  }

  renderJobseekerForm() {
    if( ! this.props.profileLoaded ) return <></>;
    return this.props.showWelcome ? this.renderWelcome() : (<></>);
  }

  renderWelcome() {
    return this.props.messages.length == 0 ? (<ChatWelcome {...this.props} />) : <></>;
  }

  renderVideoChat(actions) {
    return <VideoChat {...this.props} onEndCall={this.props.endVideoChat} actions={actions} />;
  }

  render() {
    const actions = (<>
      <IconButton
        aria-label="leave chat"
        title="Leave chat"
        onClick={this.props.leaveChat}>
        <CloseIcon />
      </IconButton>
    </>);
    if( this.props.videoChat ) {
      return this.renderVideoChat(<></>);
    }
    return this.props.ready ? (
      <Chatbox {...this.props} actions={actions}>{this.renderJobseekerForm()}</Chatbox>) : (<></>);
  }
}

const companyToProfile = (company) => {
  return {
    first_name: company.name,
    last_name: '',
    picture: company.logo,
    display_title: ''
  }
}

const mapStateToProps = state => {
  return {
    ready: state.company.loaded,
    company: state.company.data,
    title: state.company.data.name,
    rep: state.chat.peerProfile ? state.chat.peerProfile : companyToProfile(state.company.data) ,
    messages: (state.chat.messages[`${state.company.eventId}:${state.company.companyId}`] || []),
    status: (state.chat.statuses[`${state.company.eventId}:${state.company.companyId}`] || null),
    inProgress: state.profile.inProgress,
    hasProfile: (state.profile.data != null),
    profileLoaded: state.profile.loaded,
    profile: state.profile.data,
    finished: state.chat.finished,
    blockSends: state.chat.peerProfile ? false : true, // prevent Jobseeker from talking with company icon
    showWelcome: ((!state.chat.finished) && (!state.chat.peerProfile)),
    videoChat: state.chat.videoChat,
    videoChatData: state.chat.videoChatData,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    loadCompanyData: async (eventId, companyId) =>  dispatch(CompanyActions.loadCompanyData(eventId, companyId)),
    loadProfile: async () => dispatch(ProfileActions.fetchProfile()),
    subToChat: () => dispatch(ChatActions.subToChat()),
    sendMessage: (msg) => dispatch(ChatActions.sendLocalMessage(msg)),
    leaveChat: () => dispatch( CompanyActions.leaveChat() ),
    endVideoChat: () => dispatch(ChatActions.endVideoChat() ),
    submitProfileForm: () => dispatch( ProfileActions.submitProfile() ),
    sendTyping: () => dispatch(ChatActions.sendStatus('typing')),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ChatPage);
